module.exports = __webpack_public_path__ + "2119c72f8a917b72f640d83089ead431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02.png
// module id = 111
// module chunks = 1